// Angular
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
// RxJS
import { Observable } from 'rxjs';
import {AuditService} from '../../_base/services/audit.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private router: Router,
              private auditService: AuditService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        // const loggedIn = true; !loggedIn ||
        if (!(sessionStorage.getItem(this.auditService.getVarName()) !== null)) {
            this.router.navigateByUrl('/iniciar');
          }
        return true;
  }
}
